import { classNames, useEffect, useLayoutEffect, useQuery, useState } from 'libs/react';
import { appendDealFreezeDebug } from '../dealConfigureFreezeDebug';
import { DealItemPanel } from './DealItemPanel';
import { DealSummaryPanel } from './DealSummaryPanel';
import { Panel } from 'components/Panel';
import { PanelGroup } from 'components/PanelGroup';
import { Section } from 'components/Section';
import { React } from 'libs/react';
import { FieldGroupsQuery } from 'graphql/FieldGroup/queries/FieldGroupsQuery';
import { DealAdditionalInformationPanel } from './section/additionalInformation/DealAdditionalInformationPanel';
import { DealContactPanel } from './section/contact/DealContactPanel';
import { DealNotesPanel } from './section/note/DealNotePanel';
import { DealPresentationPanel } from './section/presentation/DealPresentationPanel';
import { DealTermsPanel } from './section/terms/DealTermsPanel';
import { useTranslation } from 'components/translation/TranslationProvider';
import { DealClientPanel } from './section/client/DealClientPanel';
import { DealConfigurationPanel } from './section/configuration/DealConfigurationPanel';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { DealPaymentPanel } from './section/payment/DealPaymentPanel';
import { DealClientNotesPanel } from './section/clientNotes/DealClientNotesPanel';
import { Requires } from 'components/user/Requires';
import { useAccount } from 'components/account/AccountProvider';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import './DealConfigurator.scss';
import { DealPlannedDatePanel } from './section/additionalInformation/DealPlannedDatePanel';
/**
 * @component DealConfigurator
 * @since 1.0.0
 */
export function DealConfigurator(props) {
    var _a;
    const { style, deal } = Object.assign({}, props);
    const { dealTotal, browsePicker } = useDealConfiguratorContext();
    const account = useAccount();
    const hasDeposit = getConfigurationFieldValue((_a = account.configs) !== null && _a !== void 0 ? _a : [], 'HAS_DEPOSIT') === 'TRUE';
    const { customLabels, language } = useTranslation();
    const [initialRender, setInitialRender] = useState(true);
    const [dataFieldGroup] = useQuery(FieldGroupsQuery, {
        variables: {
            input: {
                query: [
                    {
                        field: 'category',
                        value: 'DEAL'
                    }
                ]
            }
        }
    });
    useEffect(() => {
        appendDealFreezeDebug('mount.DealConfigurator');
    }, []);
    useEffect(() => {
        var _a, _b;
        appendDealFreezeDebug(`DealConfigurator.FieldGroupsDeal.snapshot groups=${(_b = (_a = dataFieldGroup === null || dataFieldGroup === void 0 ? void 0 : dataFieldGroup.fieldGroups) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 'null'}`);
    }, [dataFieldGroup]);
    useLayoutEffect(() => {
        if ((!deal.items || deal.items.length === 0) && initialRender) {
            setInitialRender(false);
            //browsePicker(true);
        }
    }, [deal]);
    const className = classNames('deal-configurator', 'deal-configurator--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(Section, null,
            React.createElement(PanelGroup, null,
                React.createElement(Panel, { title: t('Quote Information'), collapsible: true },
                    React.createElement(Requires, { permission: "deal.plannedDate" },
                        React.createElement(DealPlannedDatePanel, { deal: deal })),
                    (dataFieldGroup === null || dataFieldGroup === void 0 ? void 0 : dataFieldGroup.fieldGroups.some((fieldGroup) => fieldGroup.fields.length !== 0)) && (React.createElement(DealAdditionalInformationPanel, { dataFieldGroup: dataFieldGroup })),
                    React.createElement(DealNotesPanel, { deal: deal })))),
        React.createElement(Section, null,
            React.createElement(PanelGroup, null,
                React.createElement(Panel, { title: customLabels['Contact'][language], collapsible: true },
                    React.createElement(DealContactPanel, { deal: deal })),
                React.createElement(Panel, { title: customLabels['Client'][language], collapsible: true },
                    React.createElement(DealClientPanel, { deal: deal })))),
        deal.items && (React.createElement(Section, null, deal.items.map((item) => (React.createElement(DealItemPanel, { key: item.id, deal: deal, item: item }))))),
        React.createElement(Section, null,
            React.createElement(PanelGroup, null,
                React.createElement(DealSummaryPanel, { deal: deal, editable: true }))),
        React.createElement(Section, null,
            React.createElement(PanelGroup, null,
                React.createElement(Panel, { title: t('Notes'), collapsible: true },
                    React.createElement(DealClientNotesPanel, { deal: deal })))),
        React.createElement(Requires, { permission: "deal.payment.manage" },
            React.createElement(Section, null,
                React.createElement(PanelGroup, null,
                    React.createElement(Panel, { title: t('Payments'), collapsible: true },
                        React.createElement(DealPaymentPanel, { deal: deal, dealTotal: dealTotal, editable: true, hasDeposit: hasDeposit }))))),
        React.createElement(Section, null,
            React.createElement(PanelGroup, null,
                React.createElement(Panel, { title: t('Settings'), collapsible: true },
                    React.createElement(DealPresentationPanel, { deal: deal }),
                    React.createElement(DealTermsPanel, { deal: deal }),
                    React.createElement(DealConfigurationPanel, null))))));
}
